import { Briefcase, CheckCircle } from "lucide-react";

const DepartmentsSection = ({ t, styles, selectedCompanies, departmentsByCompany, selectedDepartments, onToggle, onToggleAll, onToggleAllGlobal, theme }) => (
  <div style={{
    borderRadius: "12px",
    border: `2px solid ${theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)"}`,
    padding: "20px",
    backgroundColor: theme === "dark" ? "rgba(30,41,59,0.5)" : "rgba(248,250,252,0.8)",
    background: theme === "dark"
      ? "linear-gradient(135deg, rgba(30,41,59,0.5) 0%, rgba(15,23,42,0.3) 100%)"
      : "linear-gradient(135deg, rgba(248,250,252,0.8) 0%, rgba(240,249,255,0.6) 100%)",
    transition: "all 0.3s ease"
  }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Briefcase size={20} style={{ color: "#f59e0b" }} />
        <div style={{
          fontSize: "15px",
          fontWeight: "700",
          color: theme === "dark" ? "#f1f5f9" : "#0f172a"
        }}>
          {t.departments}
        </div>
      </div>
      {selectedCompanies.length > 0 && (
        <label style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          padding: "6px 12px",
          borderRadius: "6px",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
          <input
            type="checkbox"
            checked={selectedCompanies.every((co) => {
              const depts = departmentsByCompany[co] || [];
              const selectedDepts = selectedDepartments[co] || [];
              return depts.length > 0 && depts.every((d) => selectedDepts.includes(d));
            })}
            onChange={onToggleAllGlobal}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
              accentColor: "#f59e0b"
            }}
          />
          <span style={{ fontSize: "13px", fontWeight: "500", color: theme === "dark" ? "#cbd5e1" : "#475569" }}>{t.selectAll}</span>
        </label>
      )}
    </div>
    {selectedCompanies.length === 0 ? (
      <div style={{
        padding: "20px 16px",
        borderRadius: "8px",
        backgroundColor: theme === "dark" ? "rgba(226,232,240,0.05)" : "rgba(251, 146, 60, 0.05)",
        border: `1px dashed ${theme === "dark" ? "rgba(226,232,240,0.2)" : "rgba(251, 146, 60, 0.2)"}`,
        textAlign: "center",
        color: theme === "dark" ? "rgba(226,232,240,0.6)" : "rgba(15,23,42,0.6)",
        fontSize: "13px"
      }}>
        {t.selectAtLeastOne}
      </div>
    ) : (
      selectedCompanies.map((co) => {
        const depts = departmentsByCompany[co] || [];
        const selectedDepts = selectedDepartments[co] || [];
        
        return (
          <div key={co} style={{
            marginBottom: "16px",
            borderRadius: "10px",
            padding: "16px",
            backgroundColor: theme === "dark" ? "rgba(15,23,42,0.6)" : "rgba(255,255,255,0.5)",
            border: `1px solid ${theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.08)"}`
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <div style={{
                fontSize: "14px",
                fontWeight: "700",
                color: theme === "dark" ? "#cbd5e1" : "#334155"
              }}>
                {co} ({selectedDepts.length}/{depts.length})
              </div>
              {depts.length > 0 && (
                <label style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                  padding: "4px 10px",
                  borderRadius: "6px",
                  transition: "all 0.2s ease",
                  fontSize: "12px"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
                  <input
                    type="checkbox"
                    checked={depts.length > 0 && depts.every((d) => selectedDepts.includes(d))}
                    onChange={() => onToggleAll(co)}
                    style={{
                      width: "16px",
                      height: "16px",
                      cursor: "pointer",
                      accentColor: "#f59e0b"
                    }}
                  />
                  <span style={{ fontWeight: "500", color: theme === "dark" ? "#cbd5e1" : "#475569" }}>{t.selectAll}</span>
                </label>
              )}
            </div>
            <div style={{ display: "grid", gap: "8px" }}>
              {depts.length === 0 ? (
                <p style={{ margin: 0, fontSize: "12px", color: theme === "dark" ? "rgba(226,232,240,0.4)" : "rgba(15,23,42,0.4)" }}>{t.noDepartments}</p>
              ) : (
                depts.map((dept) => {
                  const isSelected = selectedDepts.includes(dept);
                  return (
                    <button
                      key={`${co}__${dept}`}
                      onClick={() => onToggle(co, dept)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                        padding: "12px 14px",
                        borderRadius: "8px",
                        border: `1px solid ${isSelected ? "rgba(245, 158, 11, 0.3)" : theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.08)"}`,
                        backgroundColor: isSelected ? "rgba(245, 158, 11, 0.12)" : "transparent",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        background: "none",
                        fontFamily: "inherit",
                        textAlign: "left"
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.05)" : "rgba(15,23,42,0.03)";
                          e.currentTarget.style.transform = "translateX(4px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.transform = "translateX(0)";
                        }
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "14px", flex: 1 }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => onToggle(co, dept)}
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                            accentColor: "#f59e0b",
                            flexShrink: 0
                          }}
                        />
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "6px",
                          backgroundColor: "rgba(245, 158, 11, 0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#f59e0b",
                          fontWeight: "700",
                          fontSize: "13px",
                          flexShrink: 0
                        }}>
                          🏢
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{
                            fontWeight: isSelected ? "600" : "500",
                            fontSize: "13px",
                            color: isSelected ? "#f59e0b" : (theme === "dark" ? "#cbd5e1" : "#334155"),
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}>
                            {dept}
                          </div>
                        </div>
                      </div>
                      {isSelected && <CheckCircle size={20} style={{ color: "#f59e0b", flexShrink: 0 }} />}
                    </button>
                  );
                })
              )}
            </div>
          </div>
        );
      })
    )}
  </div>
);

export default DepartmentsSection;

